import { render, staticRenderFns } from "./DoctorInfo.vue?vue&type=template&id=3e48f6f7&scoped=true"
import script from "./DoctorInfo.vue?vue&type=script&lang=js"
export * from "./DoctorInfo.vue?vue&type=script&lang=js"
import style0 from "./DoctorInfo.vue?vue&type=style&index=0&id=3e48f6f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e48f6f7",
  null
  
)

export default component.exports